import { useNotepadStore } from '../../stores/notepadStore'
import './Notepad.css'

export default function Notepad() {
  const { content, setContent, filename, clear } = useNotepadStore()

  const handleClear = () => {
    if (confirm('Clear all text?')) {
      clear()
    }
  }

  const wordCount = content.trim() ? content.trim().split(/\s+/).length : 0
  const lineCount = content.split('\n').length

  return (
    <div className="notepad-app">
      <div className="notepad-toolbar">
        <span className="notepad-filename">{filename}</span>
        <div className="notepad-actions">
          <button onClick={handleClear}>Clear</button>
        </div>
      </div>

      <textarea
        className="notepad-textarea"
        value={content}
        onChange={(e) => setContent(e.target.value)}
        spellCheck={false}
        placeholder="Type something..."
      />

      <div className="notepad-statusbar">
        <span>Lines: {lineCount}</span>
        <span>Words: {wordCount}</span>
        <span>Chars: {content.length}</span>
      </div>
    </div>
  )
}
